// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  display: flex;
  height: 0px;
  width: 100%;
  background-color: white;
  opacity: 0;
  animation: animate-hder 1.3s 5s forwards ease-in-out;
  opacity: 0;
  transition: 1s all ease-in-out;
}

.header-logo {
  display: flex;
  flex-direction: row;
  width: 300px;
  height: 80px;
  cursor: pointer;
  align-items: center;
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  background-color: rgb(244, 244, 244);
  border-radius: 4px;
}

.header-logo:hover {
  z-index: 1;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
}

img {
  width: 100%;
  height: 100%;
}

@keyframes animate-hder {
  0% {
    opacity: 0;
    height: 0;
  }
  100% {
    opacity: 1;
    height: 80px;
  }
}
.link-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: end;
  align-self: center;
  transition: 0.5s all ease-in-out;
}

.nav-links {
  margin: 5px;
  padding: 0 10px;
  font-family: "Alegreya Sans SC", sans-serif;
  font-size: 18px;
  text-decoration: none;
  height: 100%;
  color: #1d3557;
  transition: 0.5s all ease-in-out;
}

.nav-links:hover {
  border-left: 10px solid #a5e300;
  border-bottom: 10px solid #337def;
  color: #1d3557;
  font-size: 15px;
  font-weight: bold;
  transition: 0.3s all ease-in-out;
}

@media (max-width: 500px) {
  .header-logo {
    display: none;
  }
  .nav-links {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,oDAAA;EACA,UAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,oCAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,2BAAA;EACA,8CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,SAAA;EACF;EACA;IACE,UAAA;IACA,YAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;EACA,2CAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;AAAF;;AAGA;EACE,+BAAA;EACA,iCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;EAGA;IACE,iBAAA;EADF;AACF","sourcesContent":[".header-container {\n  display: flex;\n  height: 0px;\n  width: 100%;\n  background-color: white;\n  opacity: 0;\n  animation: animate-hder 1.3s 5s forwards ease-in-out;\n  opacity: 0;\n  transition: 1s all ease-in-out;\n}\n\n.header-logo {\n  display: flex;\n  flex-direction: row;\n  width: 300px;\n  height: 80px;\n  cursor: pointer;\n  align-items: center;\n  box-sizing: inherit;\n  -webkit-font-smoothing: antialiased;\n  background-color: rgba(244, 244, 244, 1);\n  border-radius: 4px;\n}\n\n.header-logo:hover {\n  z-index: 1;\n  transform: translateY(-1px);\n  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\n@keyframes animate-hder {\n  0% {\n    opacity: 0;\n    height: 0;\n  }\n  100% {\n    opacity: 1;\n    height: 80px;\n  }\n}\n\n.link-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: end;\n  align-self: center;\n  transition: 0.5s all ease-in-out;\n}\n\n.nav-links {\n  margin: 5px;\n  padding: 0 10px;\n  font-family: \"Alegreya Sans SC\", sans-serif;\n  font-size: 18px;\n  text-decoration: none;\n  height: 100%;\n  color: #1d3557;\n  transition: 0.5s all ease-in-out;\n}\n\n.nav-links:hover {\n  border-left: 10px solid #a5e300;\n  border-bottom: 10px solid #337def;\n  color: #1d3557;\n  font-size: 15px;\n  font-weight: bold;\n  transition: 0.3s all ease-in-out;\n}\n\n@media (max-width: 500px) {\n  .header-logo {\n    display: none;\n  }\n\n  .nav-links {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
